import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

type EmployerManager = {
    id: string;
    text: string;
    additional: { shortFirstName: string; shortMiddleName: string; lastName: string; char: string };
};
export type EmployerManagersList = EmployerManager[];

export default autoGeneratedReducer<EmployerManagersList>([]);
